<div class="container mt-5 mb-4" *ngIf="plan">
    <div class="row justify-content-center">
        <div class="col-lg-6">
            <div class="bg-card-new card-radius-x1">
                <h4 class="card-header plan-title">{{translateHelper.localize(plan.name)}}</h4>
                <!-- <mat-divider></mat-divider> -->
                <div class="card-body">
                    <div class="plan-item" *ngIf="plan.annualFee">
                        <div class="details">
                            <div class="title">
                                <h3>{{translateHelper.localize(plan.subscriptionDuration)}}</h3>
                            </div>
                        </div>
                        <div class="support-currency" [class.active]="plan.annualFee">
                            <b>{{plan.annualFee|currencyFormat:null:null:"1.0"}}</b>
                        </div>
                    </div>
                    <!-- <h3 class="text-center mb-3">{{ "features"|translate }}</h3> -->
                    <div class="plan-item" *ngFor="let item of plan.features">
                        <div class="details">
                            <div class="title">{{translateHelper.localize(item.name)}}</div>
                            <div class="description">{{translateHelper.localize(item.description)}}</div>
                        </div>
                        <div class="support" [class.active]="item.value">
                            <ng-container *ngIf="isBoolean(item.value); else supportingText;">
                                <mat-icon>{{item.value ? 'done' : 'close'}}</mat-icon>
                            </ng-container>
                            <ng-template #supportingText>
                                <b>{{item.value}}</b>
                            </ng-template>
                        </div>
                    </div>
                    <mat-divider class="my-4"></mat-divider>
                    <div class="plan-item">
                        <div *ngIf="plan.marketingFee" [formGroup]='form'>
                            <mat-checkbox formControlName="marketing"></mat-checkbox>
                        </div>
                        <div class="details">
                            <h3 class="mb-3">{{ "included_marketing"|translate }}</h3>
                            <!--  <div class="description">{{translateHelper.localize(item.description)}}</div>   -->
                        </div>
                        <div class="support-currency" [class.active]="plan.marketingFee">

                            <b *ngIf="plan.marketingFee">{{plan.marketingFee|currencyFormat:null:null:"1.0"}} </b>
                        </div>
                    </div>
                    <div class="plan-item" *ngFor="let item of plan.marketing">
                        <div class="details">
                            <div class="title">{{translateHelper.localize(item.name)}}</div>
                            <div class="description">{{translateHelper.localize(item.description)}}</div>
                        </div>
                        <div class="support" [class.active]="item.value">
                            <ng-container *ngIf="isBoolean(item.value); else supportingText;">
                                <mat-icon>{{item.value ? 'done' : 'close'}}</mat-icon>
                            </ng-container>
                            <ng-template #supportingText>
                                <b>{{item.value}}</b>
                            </ng-template>
                        </div>
                    </div>
                    <mat-divider class="my-4"></mat-divider>
                    <h3 class="text-center mb-3 bonuses-header">{{ "signup_bonuses"|translate }}</h3>
                    <div class="plan-item" *ngFor="let item of plan.promotions">
                        <div class="details">
                            <div class="title">{{translateHelper.localize(item.name)}}</div>
                            <div class="description">{{translateHelper.localize(item.description)}}</div>
                        </div>
                        <div class="support-currency" [class.active]="item.value">
                            <b>{{"worth"|translate}} {{item.value|currencyFormat:null:null:"1.0"}}</b>
                        </div>
                    </div>
                    <mat-divider class="my-4"></mat-divider>
                    <h3 class="text-center mb-3">{{ "additional_services"|translate }}</h3>
                    <div class="plan-item plan-services items-center" *ngFor="let item of plan.services">
                        <div class="">
                            <mat-checkbox (change)="updateServices($event, item)" [checked]="selectedServicesStatus[item._id]" [value]="item"></mat-checkbox>
                        </div>
                        <div class="details" (click)="toggleService(item)">
                            <div class="title">{{translateHelper.localize(item.name)}}</div>
                            <div class="description">{{translateHelper.localize(item.description)}}</div>
                        </div>
                        <div class="support-currency" (click)="toggleService(item)" [class.active]="selectedServicesStatus[item._id]">
                            <b *ngIf="(item.annualFee?.value ?? item.annualFee) > 0">{{item.annualFee?.value ?? item.annualFee ?? 0|currencyFormat:null:null:"1.0"}} {{"annually"|translate}}</b>
                            <b *ngIf="(item.oneTimeFee?.value ?? item.oneTimeFee) > 0">{{item.oneTimeFee?.value ?? item.oneTimeFee ?? 0|currencyFormat:null:null:"1.0"}} {{"one_time"|translate}}</b>
                        </div>
                    </div>
                    <mat-divider class="my-4"></mat-divider>
                    <a class="btn btn-primary m-auto w-1/2" [ngClass]="{ disabled: submitting }"
                        (click)="submit()">{{"submit"|translate}}</a>
                </div>
            </div>
        </div>
    </div>
</div>
